import PropTypes from 'prop-types'
import React from 'react'
import ReactSelect from 'react-select'
import { isEmpty, get } from 'lodash'
import cx from 'classnames'
import classes from './FormSelect.scss'

import MdExpandMore from 'react-icons/lib/md/expand-more'

import mediaQueryMatches from 'helpers/mediaQuery'

import FormLabel from '../Label'

export class FormSelect extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isMobile: false,
      touched: false
    }
  }

  componentDidMount () {
    if (this.props.noMobileSearch) {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  onInputKeyDown = event => {
    if (this.state.touched) return // already touched, no need to check again

    if (
      (event.keyCode >= 48 && event.keyCode <= 90) || // between 0...a...z
      (event.keyCode >= 96 && event.keyCode <= 105) || // between 0...9 (numpad)
      [38, 40].includes(event.keyCode) // up and down
    ) {
      this.setState({ touched: true })
    }
  };

  onChange = newValue => {
    if (isEmpty(newValue)) newValue = null // this could be an empty array....?
    const touched = !!(newValue && typeof newValue.value !== 'undefined' ? newValue.value : newValue) // could be an object?

    // if newValue is blank, touched is false
    this.setState({ touched })
    if (typeof this.props.onChange === 'function') this.props.onChange(newValue)
  };

  getFilterOption = () => { // only returns a custom filterOption when a prop is passed
    if (!this.props.filterModelFields || !this.props.filterModelFields.length) return

    return (option, filterBy) => {
      if (!option || !filterBy) return true

      const handleString = (string) => {
        if (string) string = String(string)
        if (string && this.props.ignoreAccents) string = string.stripDiatrics()
        if (string && this.props.ignoreCase) string = string.toLowerCase()
        return string
      }

      filterBy = handleString(filterBy)

      let filters = this.props.filterFields
      let modelFilters = this.props.filterModelFields.map(s => `model.${s}`)
      if (option && option.model) filters = [...filters, ...modelFilters] // concat

      return filters.some(key => {
        let value = handleString(get(option, key))
        if (value && value.includes(filterBy)) return true
        return false
      })
    }
  };

  getMatchProp = () => {
    // map filterFields to this
    if (!this.props.filterFields) return 'any'
    if (this.props.filterFields.includes('value') && this.props.filterFields.includes('label')) return 'any'
    if (this.props.filterFields.includes('value')) return 'value'
    if (this.props.filterFields.includes('label')) return 'label'
    return 'any'
  };

  handleResize = () => {
    const matches = mediaQueryMatches('medium', 'max') // NOTE: Matches can be undefined, which means it had an error

    if (matches) {
      this.setState({ isMobile: true })
    } else {
      this.setState({ isMobile: false })
    }
  };

  arrowRenderer = () => {
    return <MdExpandMore />
  };

  render () {
    let className = { [classes['select']]: classes['select'] }
    this.props.options.forEach((option) => {
      className[classes[`select--${option}`]] = classes[`select--${option}`]
      className[`is-${option}`] = true // NOTE: Not a CSS Module! For use with react-select styling overrides..
    })
    className = cx(className)

    return <FormLabel {...this.props}>
      <ReactSelect
        {...this.props}
        className={className}

        onInputKeyDown={this.onInputKeyDown}
        onChange={this.onChange}
        onBlur={() => this.props.onBlur(this.props.value)}

        autoBlur
        searchable={
          this.props.searchable !== undefined
            ? this.props.searchable
            : this.props.noMobileSearch
              ? !this.state.isMobile
              : true // default searchable
        }
        openOnFocus={this.props.openOnFocus}
        placeholder={this.props.placeholder}
        tabSelectsValue={
          this.props.betterTabSelectsValue
            ? this.state.touched // use touched state as a true/false
            : this.props.tabSelectsValue // regular
        }
        disabled={!!this.props.disabled}
        multi={this.props.multi}
        clearable={this.props.clearable}
        options={this.props.selectOptions}
        menuRenderer={this.props.menuRenderer}
        optionRenderer={this.props.optionRenderer}
        valueRenderer={this.props.valueRenderer}
        arrowRenderer={this.props.arrowRenderer || this.arrowRenderer}
        filterOption={this.props.filterOption || this.getFilterOption()}

        inputProps={this.props.inputProps}
        matchProp={this.getMatchProp()}

        ref={ref => (this.ReactSelect = ref)}
      />
    </FormLabel>
  }
}

FormSelect.propTypes = {
  // from redux-form or general form inputs
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  input: PropTypes.array,
  options: PropTypes.array,
  value: PropTypes.any,
  placeholder: PropTypes.string,

  // for react-select
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired
  })),
  searchable: PropTypes.bool,
  noMobileSearch: PropTypes.bool,
  tabSelectsValue: PropTypes.bool,
  clearable: PropTypes.bool,
  disabled: PropTypes.bool,
  multi: PropTypes.bool,
  openOnFocus: PropTypes.bool,
  menuRenderer: PropTypes.func,
  optionRenderer: PropTypes.func,
  valueRenderer: PropTypes.func,
  arrowRenderer: PropTypes.func,
  filterOption: PropTypes.func,
  filterFields: PropTypes.array, // NOTE: This overrides ReactSelect.matchProp..
  filterModelFields: PropTypes.array, // NOTE: This overrides the default filterOption (when no filterOption function is sent)
  inputProps: PropTypes.object,
  betterTabSelectsValue: PropTypes.bool,

  ignoreAccents: PropTypes.bool,
  ignoreCase: PropTypes.bool
}

FormSelect.defaultProps = {
  selectOptions: [],
  options: ['expandable'],
  tabSelectsValue: true,
  clearable: true,
  multi: false,
  openOnFocus: true,
  placeholder: 'select...',
  value: '',
  filterFields: ['label'],
  filterModelFields: [],
  ignoreAccents: true,
  ignoreCase: true,
  inputProps: {},
  betterTabSelectsValue: true
}

export default FormSelect



// WEBPACK FOOTER //
// ./src/components/Form/Select/FormSelect.js